import {
  BadgePlus,
  Bell,
  BookOpenCheck,
  CalendarCheck2,
  CircleEllipsis,
  ClipboardCheck,
  FileKey2,
  FileStack,
  Import,
  LifeBuoy,
  Settings,
  ScrollText,
  Users,
  WalletCards,
} from 'lucide-react';
import CommandGatewayIcon from './CommandGatewayIcon';

export const relyNavigationIcons = Object.freeze({
  passport: BookOpenCheck,
  evidence: FileStack,
  signals: Bell,
  accounts: WalletCards,
  more: CircleEllipsis,
  command: CommandGatewayIcon,
  approvals: ClipboardCheck,
  compliance: CalendarCheck2,
  benefits: BadgePlus,
  support: LifeBuoy,
  referrals: Users,
  settings: Settings,
  newCompany: BadgePlus,
  importCompany: Import,
  invoices: ScrollText,
  monthlyClose: CalendarCheck2,
  provider: FileKey2,
});

export const relyNavigationIconNames = Object.freeze({
  passport: 'book-open-check',
  evidence: 'file-stack',
  signals: 'bell',
  accounts: 'wallet-cards',
  more: 'circle-ellipsis',
  command: 'gateway-core',
  approvals: 'clipboard-check',
  compliance: 'calendar-check-2',
  benefits: 'badge-plus',
  support: 'life-buoy',
  referrals: 'users',
  settings: 'settings',
  newCompany: 'badge-plus',
  importCompany: 'import',
  invoices: 'scroll-text',
  monthlyClose: 'calendar-check-2',
  provider: 'file-key-2',
});

export const relyNavigationIconKeys = Object.freeze(
  Object.keys(relyNavigationIcons)
);

export function getRelyNavigationIcon(key) {
  return relyNavigationIcons[key] || relyNavigationIcons.passport;
}

export function getRelyNavigationIconName(key) {
  return relyNavigationIconNames[key] || relyNavigationIconNames.passport;
}
